
                import "css-modules://src_components_stage_stage"
                export default {"Container":"_0300ce","Loader":"_a7f9b9","Bar":"_ac2116","Progress":"_3b1a6f","Info":"_3ee867","Percentage":"_bd2a67","Image":"_390565","Wobble":"_42c532"}
            